import { useCastPageStore } from "@/stores/CastPage";
import { type RouteLocationNormalized } from 'vue-router';

const {
    fetchCastInfo,
	clearCastMediaDetail,
	setCurrentCastItemDetail
} = useCastPageStore();

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (!import.meta.client) {
		return;
	}

	clearCastMediaDetail();

	setCurrentCastItemDetail(to.params.id as string);

	fetchCastInfo(to.params.id as string);
});